import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PublicSiteLayout from '../../components/PublicSite/PublicSiteLayout';
import { publicAccent, publicText } from '../../components/PublicSite/publicColors';
import { PRIVACY } from '../../utils/pageProse';

const Title = styled.h1`
  font-size: clamp(2rem, 4vw, 2.75rem);
  margin: 0 0 1rem;
`;

const Section = styled.section`
  margin-bottom: 1.5rem;
  max-width: 40rem;
`;

const Heading = styled.h2`
  font-size: 1.2rem;
  margin: 0 0 0.4rem;
`;

const Body = styled.p`
  margin: 0;
  color: ${publicText};
  line-height: 1.55;
`;

const TextLink = styled(Link)`
  color: ${publicAccent};
`;

const PrivacyPage = (): JSX.Element => {
  return (
    <PublicSiteLayout>
      <Title>Privacy</Title>
      <Section>
        <Heading>What is stored</Heading>
        <Body>
          {PRIVACY.stored} {PRIVACY.analytics}
        </Body>
      </Section>
      <Section>
        <Heading>What we do not do</Heading>
        <Body>
          {PRIVACY.notSold} {PRIVACY.thirdParties} The{' '}
          <TextLink to="/terms_of_service/#data-confidentiality">Terms of Service</TextLink> and
          the <TextLink to="/terms_of_service/#analytics">analytics section</TextLink> are the
          binding description.
        </Body>
      </Section>
      <Section>
        <Heading>If you cancel</Heading>
        <Body>
          {PRIVACY.cancel} {PRIVACY.documents} {PRIVACY.softDelete} {PRIVACY.purge} See{' '}
          <TextLink to="/account-deletion/">how account deletion works</TextLink>, including the
          soft-delete steps and what data may remain.
        </Body>
      </Section>
    </PublicSiteLayout>
  );
};

export default PrivacyPage;
